import React, { useEffect } from 'react'
import { Route, Routes, useLocation } from 'react-router'
import HomeIndex from './Pages/HomePage/homeIndex'
import { HOME } from './routeFiles/route'
import { ABOUT } from './routeFiles/route'
import { TERMS } from './routeFiles/route'
import { REFUND } from './routeFiles/route'
import { CONTACT } from './routeFiles/route'
import INCSUBHeader from './components/header/header'
import INCSUBAboutus from './Pages/Aboutus/aboutus'
import INCSUBTermsAndConditions from './Pages/termsAndConditions/termsAndConditions'
import INCRefund from './Pages/refund/refund'
import INCSUBContact from './Pages/contact/contact'

function RouterComponents() {
    const {pathname} = useLocation()

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to top on pathname change
    }, [pathname]);

    return (
        <div>
            <INCSUBHeader />
            <Routes>
                <Route path={HOME} element={<HomeIndex />} />
                <Route path={ABOUT} element={<INCSUBAboutus />} />
                <Route path={TERMS} element={<INCSUBTermsAndConditions />} />
                <Route path={REFUND} element={<INCRefund />} />
                <Route path={CONTACT} element={<INCSUBContact />} />
            </Routes>
        </div>
    )
}

export default RouterComponents
